module.exports = __webpack_public_path__ + "c3e8f2ec7fe33c98feef858af902a777.png";